import toast from 'react-hot-toast';
import { wait } from './utils';
import { info } from './message';

export function checkMain(sendMessage) {
  return new Promise((resolve, reject) => {
    window.onMainLayerChecked = async (msg) => {
      resolve(msg);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'CheckMain');
  });
}

// 异步等待获取值
async function getTexerImages(key) {
  const val = getTexerImagesDid(key, new Date());
  return val;
}

// 异步等待获取值
async function getTexerImagesDid(key, start) {
  const val = window.texerImages[key];
  if (!val) {
    await wait(200);
    const now = new Date();
    if (now.getTime() - start.getTime() > 20000) {
      info('No value was retrieved, please start again.');
      return undefined;
    }
    return await getTexerImagesDid(key, start);
  } else {
    return val;
  }
}

export function checkInpaintArea(sendMessage) {
  return new Promise((resolve, reject) => {
    window.onVirtualLayerChecked = async (msg) => {
      resolve(msg);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'CheckInpaintArea');
  });
}

export function getScreenShot(sendMessage) {
  clearTexerImages();
  return new Promise((resolve, reject) => {
    window.onImgRec = async (msg) => {
      window.onImgRec = null;
      resolve(window.texerImages[msg]);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'GetScreenShot');
  });
}

// 清除数据
function clearTexerImages() {
  window.texerImages = {};
  window.onImgRec = null;
}

export function getInpaintMaskImage(sendMessage, url) {
  clearTexerImages();
  return new Promise((resolve, reject) => {
    window.onImgRec = async (msg) => {
      window.onImgRec = null;
      const val = await getTexerImages('resultImg');
      console.log('return getInpaintMaskImage', val, msg);
      resolve(val);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'RegulateTexWithMask ' + url);
  });
}

export function getControlnetImage(sendMessage) {
  clearTexerImages();
  return new Promise((resolve, reject) => {
    console.log('return getControlnetImage====');
    window.onImgRec = async (msg) => {
      window.onImgRec = null;
      const val = await getTexerImages('controlImg');
      console.log('return getControlnetImage', val, msg);
      resolve(val);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'GetGen2DTextures');
  });
}

export function getUV(sendMessage) {
  clearTexerImages();
  return new Promise((resolve, reject) => {
    window.onImgRec = async (msg) => {
      window.onImgRec = null;
      const val = await getTexerImages('uvImg');
      console.log('return getUV', msg, window.texerImages);
      resolve(val);
    };

    sendMessage('ContextManager', 'OnCmdExec', 'GetUV');
  });
}

export function getInpaintTextures(sendMessage) {
  clearTexerImages();
  return new Promise((resolve, reject) => {
    window.returnBaseTextures = (msg) => {
      window.onImgRec = null;
      console.log('return getInpaintTextures', msg, window.texerImages);
      resolve(window.texerImages);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'GetInpaintTextures');
  });
}

// export function inpaintOriginal(sendMessage, brush) {
//   sendMessage('ContextManager', 'OnCmdExec', 'BrushOpen ' + (brush ? 0 : 1));
// }

// export function inpaintDraw(sendMessage, onInpaint) {
//   console.log('sendMessage', sendMessage);
//   sendMessage('ContextManager', 'OnCmdExec', 'OnInpaint ' + (onInpaint ? 0 : 1));
// }

// export function inpaintErase(sendMessage, open) {
//   sendMessage('ContextManager', 'OnCmdExec', 'OnInpaintErase ' + open);
// }

export function OnBrushGroupChanged(sendMessage, index, open) {
  sendMessage('ContextManager', 'OnCmdExec', `OnBrushGroupChanged ${index} ${open ? 1 : 0}`);
}

export function inpaintOriginal(sendMessage, brush) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnBrushGroupChanged 0 ' + (brush ? 0 : 1));
}

export function inpaintDraw(sendMessage, onInpaint) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnBrushGroupChanged 1 ' + (onInpaint ? 0 : 1));
}

export function inpaintErase(sendMessage, open) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnBrushGroupChanged 2 ' + open);
}

// 清除重绘制
export function clearInpainting(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnInpaintClear 1');
}

// 删除重绘制
export function deleteInpainting(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'ClearVirtual');
}

// 生成2D
export function gen2D(sendMessage) {
  return new Promise((resolve, reject) => {
    window.onImgProcDone = async () => {
      await wait(200);
      resolve();
    };
    sendMessage('ContextManager', 'OnCmdExec', 'Gen2D');
    SetLoading(sendMessage, 0);
  });
}

// export function getInpaintTextures(sendMessage) {
//   sendMessage('ContextManager', 'OnCmdExec', 'GetInpaintTextures');
// }

// 设置加载进度
export function SetLoading(sendMessage, val) {
  sendMessage('ContextManager', 'OnCmdExec', 'SetLoading ' + val);
}

// 取消生成
export function OnCancelGenerate(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnCancelGenerate');
}

// 加载模型
export function LoadModel(sendMessage, url) {
  console.log('LoadModel', url);
  sendMessage('ContextManager', 'OnCmdExec', 'Load ' + url);
}

// 加载模型
export function SetProjectImage(sendMessage, url) {
  // const url = base64ToBlob(base64);
  console.log('url', url);
  sendMessage('ContextManager', 'OnCmdExec', `SetProjectImage ${url}`);
}
// 清除所有的图层
export function OnDiscardLayers(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnDiscardLayers 1');
}
// 重置画布图层
export function resetLayer(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'resetLayer');
}
// 重置投影器
export function reset(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'reset');
}
// 根据uv设置贴图
export function setLayerTexture(sendMessage, url) {
  sendMessage('ContextManager', 'OnCmdExec', 'SetLayerTexture ' + url);
}

// 设置ControlNetMode
export function SetControlNetMode(sendMessage, index) {
  sendMessage('ContextManager', 'OnCmdExec', 'SetControlNetMode ' + index);
}
export function onUVChanged(sendMessage, val) {
  sendMessage('ContextManager', 'OnCmdExec', 'onUVChanged ' + val);
}

//设置系统清晰度 {等级} 0 = 预览，1 = 标准
export function setDefinition(sendMessage, val) {
  sendMessage('ContextManager', 'OnCmdExec', 'SetDefinition ' + val);
}

//调整笔刷大小
export function adjustBrushSize(sendMessage, val) {
  sendMessage('ContextManager', 'OnCmdExec', 'AdjustBrushSize ' + val);
}

// webgl 让input 失效
export function disableWebGLInput(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'DisableWebGLInput');
}

// webgl 让input 生效
export function enableWebGLInput(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'EnableWebGLInput');
}
